<footer class="footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-6 col-xs-12 offset-xs-0 offset-md-6">
        <div style="text-align: right">
          <!-- mospina 10-10-16 EPT-2100 Versionamiento AVATAR -->
          <h5 class="color">
            © {{year}} AVATARSYS · Front v{{ versionFront }}
            <ng-container *ngIf="versionBack$ | async as vb"> · Back v{{ vb }}</ng-container>
            Derechos Reservados | Desarrollado por <img src="assets/images/Logo.png" style="height: 2em">
          </h5>
        </div>
      </div>
    </div>
  </div>
</footer>

<!-- Botón flotante -->
<!-- <div
  *ngIf="acceso"
  class="chat-fab"
  role="button"
  aria-label="Abrir chat"
  tabindex="0"
  (click)="toggleChat()"
  (keyup.enter)="toggleChat()"
  [attr.aria-expanded]="chatAbierto">
  <img src="assets/images/avatar-ia-v1.png" alt="Asistente Virtual" class="chat-fab-avatar" />
  <i class="bx bx-x chat-close-icon" *ngIf="chatAbierto" aria-hidden="true"></i>
</div> -->

<!-- Contenedor del Chat -->
<!-- <div *ngIf="acceso" class="chat-float-box" [ngClass]="{'chat-float-open': chatAbierto}">
  <ejs-chatui
    #chatUI
    headerText="Asistente Virtual"
    [user]="currentUser"
    [messages]="messages"
    [suggestions]="suggestions"
    locale="es"
    placeholder="Escribe un mensaje..."
    (messageSend)="onMessageSend($event)">
  </ejs-chatui>
</div> -->